<div class="onboarding-page">
  <!-- Success state -->
  <div *ngIf="created as c" class="result-card">
    <lib-cdw-icon class="result-icon" icon="check_circle" size="44px"></lib-cdw-icon>
    <h2 class="result-title">Customer created</h2>
    <p class="result-sub">
      <strong>{{ c.name }}</strong> is created. Verify domain-wide delegation from
      its detail page, then its Super Admins can sign in.
    </p>

    <dl class="result-grid">
      <div><dt>Name</dt><dd>{{ c.name }}</dd></div>
      <div><dt>Primary domain</dt><dd>{{ c.primaryDomain || '—' }}</dd></div>
      <div><dt>Google ID</dt><dd>{{ c.googleId }}</dd></div>
    </dl>

    <div class="result-actions">
      <lib-cdw-button level="primary" type="button" (buttonClick)="onboardAnother()">
        Onboard another
      </lib-cdw-button>
    </div>
  </div>

  <!-- Form state -->
  <form *ngIf="!created" class="form-card" [formGroup]="form" (ngSubmit)="submit()">
    <div class="form-intro">
      <h2 class="form-title">Onboard a customer</h2>
      <p class="form-sub">
        Creates the customer record. Verify domain-wide delegation afterward from
        the customer's detail page.
      </p>
    </div>

    <div class="field">
      <lib-common-ui-components-text-input
        formControlName="name"
        label="Customer name"
        placeholder="Springfield USD"
        [required]="true"
        [hideRequiredMarker]="true"
        size="100%"
      ></lib-common-ui-components-text-input>
      <div
        class="field-error"
        *ngIf="nameControl.touched && nameControl.invalid"
      >
        A customer name is required.
      </div>
    </div>

    <div class="field">
      <lib-common-ui-components-text-input
        formControlName="primaryDomain"
        label="Primary domain"
        placeholder="school.edu"
        [required]="true"
        [hideRequiredMarker]="true"
        size="100%"
      ></lib-common-ui-components-text-input>
      <div
        class="field-error"
        *ngIf="primaryDomainControl.touched && primaryDomainControl.invalid"
      >
        Enter a bare domain (e.g. school.edu) — no protocol, no spaces.
      </div>
    </div>

    <div class="field">
      <lib-common-ui-components-text-input
        formControlName="googleId"
        label="Google customer ID"
        placeholder="C02c9bmnt"
        [required]="true"
        [hideRequiredMarker]="true"
        size="100%"
      ></lib-common-ui-components-text-input>
      <div
        class="field-error"
        *ngIf="googleIdControl.touched && googleIdControl.invalid"
      >
        Enter a Google customer ID (e.g. C02c9bmnt).
      </div>
    </div>

    <div class="field">
      <lib-common-ui-components-text-input
        formControlName="delegateEmail"
        label="Delegate account (optional)"
        placeholder="gopher@school.edu"
        size="100%"
      ></lib-common-ui-components-text-input>
    </div>

    <div class="field">
      <lib-common-ui-components-text-input
        formControlName="schoolDistrict"
        label="School district (optional)"
        size="100%"
      ></lib-common-ui-components-text-input>
    </div>

    <div class="field-row">
      <div class="field">
        <lib-cdw-select
          formControlName="timezone"
          label="Timezone"
          [values]="timezoneOptions"
          inputWidth="100%"
        ></lib-cdw-select>
      </div>
      <div class="field">
        <lib-cdw-select
          formControlName="dateFormat"
          label="Date format"
          [values]="dateFormatOptions"
          inputWidth="100%"
        ></lib-cdw-select>
      </div>
    </div>

    <!-- No delegate entered: require an explicit confirmation. A customer with
         no delegate can't pass DWD or sign in until one is assigned. -->
    <div *ngIf="delegateMissing" class="delegate-confirm">
      <lib-cdw-checkbox [(ngModel)]="confirmNoDelegate" [ngModelOptions]="{ standalone: true }">
        No delegate account — I'm creating this customer without one and
        understand its users can't sign in until a delegate is assigned.
      </lib-cdw-checkbox>
    </div>

    <div class="form-error" *ngIf="errorMessage">
      <lib-cdw-icon icon="error" size="20px"></lib-cdw-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="form-actions">
      <lib-cdw-button
        level="primary"
        type="submit"
        [disabled]="isSubmitting || form.invalid || (delegateMissing && !confirmNoDelegate)"
      >
        {{ isSubmitting ? 'Creating…' : 'Create customer' }}
      </lib-cdw-button>
    </div>
  </form>
</div>
